import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectCanManageNotifications } from '@store/selectors/user/user.selectors';

@Component({
  selector: 'app-information-hub',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule],
  templateUrl: './information-hub.component.html',
  styleUrl: './information-hub.component.css',
})
export class InformationHubComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly destroy$ = new Subject<void>();

  canManage = false;

  ngOnInit(): void {
    this.store.select(selectCanManageNotifications)
      .pipe(takeUntil(this.destroy$))
      .subscribe((can) => { this.canManage = can; });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
